import { render } from "./ProductPrice.vue?vue&type=template&id=49599d9d&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"

import "./ProductPrice.vue?vue&type=style&index=0&id=49599d9d&lang=scss&scoped=true"

import exportComponent from "/Users/jason.pollock/Containers/globaltech/packages/fool-wp-commerce/vue-commerce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49599d9d"]])

export default __exports__